import { render } from "./QuillEditor.vue?vue&type=template&id=567a1b03&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"

import "./QuillEditor.vue?vue&type=style&index=0&id=567a1b03&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567a1b03"]])

export default __exports__